import { TonConnectButton } from '@tonconnect/ui-react';

export function WalletButton() {
  return (
    <div className="flex items-center">
      <TonConnectButton />
    </div>
  );
}
